import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {Category, SalesWorkflow} from "projects/store/src/app/enums";


@Component({
  selector: 'app-sales-final-message',
  templateUrl: './sales-final-message.component.html'
})
export class SalesFinalMessageComponent {
  requestId: string;
  request: any
  categoryCode: string;
  flowCode: string;
  isTopUpLoan: boolean = false;
  @Input() message!: string
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
    this.isTopUpLoan = this.request?.top_up_loan ?? false;
  }

  /**
   * Determina si debe mostrar el componente kredicash
   * Considera tanto el categoryCode como el flujo app-krdya-kredicash
   */
  get isKredicash(): boolean {
    return this.categoryCode === Category.kredicash ||
           this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  protected readonly Category = Category;
}
